import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IAppState } from '../../../../../../../common/state';
import { changeMinFloorsTotal, changeMaxFloorsTotal } from '../../../../../../state/advanced/floors_total';
import { FloorsTotal, IFloorsTotalStoreProps, IFloorsTotalDispatchProps } from './floorsTotal';
import { changePenthouse } from '../../../../../../state/advanced/dwelling_status';

export function mapStateToProps(state: IAppState) {
  return {
    floorsTotal: state.filters.jsonQuery.floorn,
    isPenthouse: !!(state.filters.jsonQuery.penthouse && state.filters.jsonQuery.penthouse.value),
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onMinFloorsTotalChanged: (value: number | undefined) => {
      dispatch(changeMinFloorsTotal(value));
    },
    onMaxFloorsTotalChanged: (value: number | undefined) => {
      dispatch(changeMaxFloorsTotal(value));
    },
    onIsPenthouseChange: (value: boolean) => {
      dispatch(changePenthouse(value));
    },
  };
}

export const FloorsTotalContainer = connect<IFloorsTotalStoreProps, IFloorsTotalDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(FloorsTotal);
